import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SKIP_AUTH } from 'src/app/constants/ContextToken';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DshService {
  private readonly apiBase = environment.apiUrl;

  constructor(private http: HttpClient) { }

  DashboardDetails(data: any): Observable<any> {
    return this.http.post<any>(`${this.apiBase}/dsh/dashboard/details`, data)
  }
  SaveDashboard(data: any): Observable<any> {
    return this.http.post<any>(`${this.apiBase}/dsh/dashboard/save`, data)
  }
  SaveWidgetConfig(data: any): Observable<any> {
    return this.http.post<any>(`${this.apiBase}/dsh/dashboard/widget/config/save`, data)
  }
  GetDataSourceCatalogWithSourceTypeCode(status: boolean): Observable<any> {
    return this.http.get<any>(`${this.apiBase}/dsh/data-source-catalog/get-by-status-With-Source-Type-Code?status=${status}`)
  }
  getByCatalog(controllerRoute: string, catalogId: number): Observable<any> {
    return this.http.get<any>(`${this.apiBase}/${controllerRoute}/get-by-catalog-id?catalogId=${catalogId}`);
  }
  SaveDashboardSideMenu(data:any): Observable<any>{
    return this.http.post<any>(`${this.apiBase}/dsh/dashboard/save-dashboard-side-menu`, data)
  }
  getDashboardWithData(data:any): Observable<any> {
    return this.http.post<any>(`${this.apiBase}/dsh/dashboard/details-with-data`,data)
  }
}
